(function detailsDataProviderInitLambda(global) {


  /** 
  * Источник данных для грида.
  * @since 5.2.0.1300
  */
  var DetailsDataProvider = WA.CMP.dataViews.BaseDataProvider.extend({
    _DetailSectionNumber: null,
    _DFMName: null,

    init: function (initialState) {
      var me = this;

      me._super(initialState);
      me._cacheID = generateUniqueID();
      me._DetailSectionNumber = initialState.DetailSectionNumber;
      me._DFMName = initialState.DFMName;
      
      me.defaults = {
        ObjectLink: new WA.Link().toLinkModel()        
      }
      
      $.extend(me.defaults, initialState);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _makeKey: function () {
      var me = this;
      var code;
      if (WA.CR.Type === OBJECT_TYPE.EDOCUMENT) {
        code = "" + WA.CR.CardTypeCode;
      }

      if (WA.CR.Type === OBJECT_TYPE.REFERENCE_RECORD) {
        code = "" + WA.CR.getReferenceCode();
      }
      return $.toJSON([code, ""+WA.CR.getReferenceView(), ""+me._DetailSectionNumber]).replaceAll(' ','');
    },

    /**
    * @since 5.2.0.1300
    */
    makeParams: function (loadOptions) {
      var me = this;
      loadOptions.CacheID = me._cacheID;
      return me.extendDefaults(loadOptions);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @since 5.2.0.1300
    */
    load: function (loadOptions) {
      var me = this;
      var result = new $.Deferred();      
      WA.SRV.call('/CardForm.asmx/GetDetailsData', me.makeParams(loadOptions)).done(function (data) {       
        result.resolve({ Rows: $.parseJSON(data)});
      }).fail(function (e) {
        WA.ready(function () {
          var severity = (e.Severity !== "-1" ? Number(e.Severity) : undefined);
          WA.CR.inlineHint.show(e.Error, undefined, severity);
        });
        result.resolve({ Rows: [] });
      });
            
      return result.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    loadState: function () {
      var me = this;
      var result = $.Deferred();
      var jTable = $('#'+me._DFMName);
      
      //WA.cache.serverCache.getItem(me._makeKey()).done(function (data) {

      var data = jTable.data('state');
      if (data && data["ObjectLink"]) delete data["ObjectLink"]; //В профиле может быть неактуальная ссылка
      result.resolve(data);

      //}).fail(function (e) {
      //  result.reject(e);
      //});
      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    saveState: function (loadOptions, forceSaveToServer) {
      var me = this;
      var result = $.Deferred();      
      clearTimeout(me._saveSateTimeout);
      me._saveSateTimeout = setTimeout(function () {        
        WA.cache.serverCache.setItem(me._makeKey(), me.makeParams(loadOptions)).done(function () {
          result.resolve();
        }).fail(function () {
          result.reject();
        });
      }, 200);      
      return result.promise();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  // Публичные объекты.
  global.DetailsDataProvider = DetailsDataProvider;
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.grid);